const disbursementStatusConfig = {
    draft: {
        text: 'Entwurf',
        color: 'grey-3',
        textColor: 'primary',
    },
    active: {
        text: 'Aktiv',
        color: 'grey-3',
        textColor: 'primary',
    },
    completed: {
        text: 'Abgeschlossen',
        color: 'grey-3',
        textColor: 'positive',
    },
    aborted: {
        text: 'Abgebrochen',
        color: 'grey-3',
        textColor: 'negative',
    },
    archived: {
        text: 'Archiviert',
        color: 'grey-3',
        textColor: 'positive',
    },
};

export default disbursementStatusConfig;
